const TYPE = {
  FETCHING_PAYMENT_HOST: 'FETCHING_PAYMENT_HOST',
  FETCHED_PAYMENT_HOST: 'FETCHED_PAYMENT_HOST'
}

function paymentHostReducer(state, action) {
    switch (action.type) {
      case TYPE.FETCHING_PAYMENT_HOST:
        return { fetching_payment_host: true };
      case TYPE.FETCHED_PAYMENT_HOST:
        return { fetching_payment_host: false };
      default:
        return state;
    }
  }
  
  export default paymentHostReducer;